import type { ReactNode } from 'react';
import MentionsSparkline, { type SparklinePoint } from './MentionsSparkline';

export interface FactsStat {
  label: string;
  value: string | number;
  title?: string;
}

interface Props {
  badges?: ReactNode;            // type-specific solid badges (CVSS, KEV, country, …)
  stats?: FactsStat[];
  attribution?: ReactNode;       // pills row (actors/families)
  sparkline?: {
    series?: SparklinePoint[] | null;
    firstSeen?: string | null;
    lastSeen?: string | null;
  };
  borderColor?: string;          // hex from entityColors
}

export default function FactsBand({ badges, stats, attribution, sparkline, borderColor }: Props) {
  const style = borderColor ? { borderLeftColor: borderColor } : undefined;
  return (
    <section className="entity-facts-band" style={style}>
      <div className="entity-facts-label">◆ Evidence (from indexed reports)</div>

      {badges && <div className="entity-facts-badges">{badges}</div>}

      {stats && stats.length > 0 && (
        <div className="entity-facts-stats">
          {stats.map((s) => (
            <div key={s.label} className="entity-facts-stat" title={s.title}>
              <span className="entity-facts-stat-value">{s.value}</span>
              <span className="entity-facts-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      )}

      {sparkline && (sparkline.firstSeen || sparkline.lastSeen || (sparkline.series && sparkline.series.length > 0)) && (
        <MentionsSparkline {...sparkline} color={borderColor} />
      )}

      {attribution && <div className="entity-facts-attribution">{attribution}</div>}
    </section>
  );
}
